import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { createSectionFourRecord } from "../utils/create-section-four-record";

interface IRequest {
  mainJournalId: string;
  section4Id: string;
  section4ListId: string;
  itemPartOne: {
    isDefects: boolean;
    constructionControlInfo: string;
    controlEventPeriod: {
      beginDate: string;
      endDate: string;
    };
    defectsAbsenceRecord: string;
    defectRecordDate?: string;
    defectFixingPlanDate?: string;
    defectDescriptionText?: string;
    docs?: Array<any>;
    works?: Array<any>;
    otherDocuments?: Array<any>;
    structuralElementName?: string;
    locationDescription?: string;
    locationType?: string;
    inspectionEmployeeId: string;
  };
}

export const useCreateSectionFourEntry = ({
  sectionFourId,
  section4ListId,
}: {
  sectionFourId: string;
  section4ListId: string;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IRequest) => {
      return createSectionFourRecord({
        sectionFourId,
        sectionFourRequest: data,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: journalsQueries.getSection4({ section4ListId }).queryKey,
      });
      notification.success({
        message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
        description: NOTIFICATION_MESSAGES.ENTRY_CREATED_DESC, // "Запись создана"
      });
    },
    onError: () => {
      notification.error({
        message: NOTIFICATION_MESSAGES.ENTRY_CREATE_ERROR, // "Ошибка при создании записи"
        description: NOTIFICATION_MESSAGES.ENTRY_CREATE_FAILED_DESC, // "Не удалось создать запись"
      });
    },
  });
};
